import { Component, OnInit } from '@angular/core';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { FinDokument } from './fin-dokument';

@Component({
  selector: 'yt-fin-dokument-tabs',
  templateUrl: './fin-dokument-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class FinDokumentTabsComponent extends BaseTabsContainer<FinDokument> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<FinDokument>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }

}
